import { APPLICANT_VERIFICATION_ACTIONS } from "constants/actions";

export function fetchAssociatesVerificationList(companyId) {
    return {
        type: APPLICANT_VERIFICATION_ACTIONS.FETCH_ASSOCIATES_VERIFICATION_LIST,
        payload: {
            companyId
        }
    };
}

export function fetchedAssociatesVerificationList(companyId, data) {
    return {
        type: APPLICANT_VERIFICATION_ACTIONS.FETCHED_ASSOCIATES_VERIFICATION_LIST,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchAssociatesVerificationList(companyId, error) {
    return {
        type: APPLICANT_VERIFICATION_ACTIONS.FAILED_FETCH_ASSOCIATES_VERIFICATION_LIST,
        payload: {
            companyId
        },
        error
    };
}